import { customerTestInstance } from '../axios';

const getLocationsByCustomerId = (customerId: string, pagination: any, sortOrder: any) =>
  customerTestInstance.post('/location/v2/list', { filters: { isProspect: false, customerId }, pagination, sortOrder });

export default getLocationsByCustomerId;
